import { render } from "./SubHtmlArray.vue?vue&type=template&id=6a6d20f8"
import script from "./SubHtmlArray.vue?vue&type=script&lang=js"
export * from "./SubHtmlArray.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__